import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
var TYPES = ['Spacer01', 'Spacer02', 'Spacer03', 'Spacer04', 'Spacer05', 'Spacer06'];
var Spacer = function Spacer(_ref) {
  var dataHook = _ref.dataHook,
    type = _ref.type,
    getClassName = _ref.getClassName;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    "data-type": type,
    className: getClassName('spacer')
  }, /*#__PURE__*/React.createElement("span", {
    className: TYPES.find(function (t) {
      return t === type;
    })
  }));
};
Spacer.displayName = 'Spacer';
Spacer.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  type: PropTypes.string.isRequired
};
export default compose(Spacer);